/**
 * Voice latency instrumentation. Silent unless switched on explicitly, so
 * nothing is logged in production by default:
 *
 *   localStorage.setItem("voice:debug", "1")   // then reload
 *
 * Covers model load (cache hit vs cold fetch), VAD/auto-stop timing, the
 * whisper encode, and the /Voice/Interpret round-trip — the four places that
 * make up the delay between the mic tap and a populated form.
 */
const DEBUG_KEY = "voice:debug";

export function voiceDebugEnabled(): boolean {
  try {
    return typeof localStorage !== "undefined" && localStorage.getItem(DEBUG_KEY) === "1";
  } catch {
    // Storage can throw outright (private mode, blocked site data).
    return false;
  }
}

export function logVoicePerf(label: string, data: Record<string, unknown>): void {
  if (!voiceDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.info(`[voice:perf] ${label}`, data);
}
